export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    disabled: Boolean,
    placeholder: String,
    maxLength: Number,
    value: String,
    kind: String,
    required: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      focus: false,
    };
  },
  computed: {
    classModifiers() {
      return {
        textarea: true,
        "textarea--has-label": !!this.label,
        [`textarea--${this.theme}`]: this.theme,
      };
    },
    isOneLine() {
      if (this.kind !== "one-line") return false;
      if (this.value && this.value.length >= 30) return false;
      if (this.value && this.value.indexOf("\n") > -1) return false;
      return true;
    },
    classHasValue() {
      return {
        "textarea__box--is-focused": this.focus,
        "textarea__box--is-disabled": this.disabled,
        "textarea__box--is-incorrect": false,
        "textarea__box--one-line": this.isOneLine,
      };
    },
  },
  methods: {
    handleBlur(e) {
      this.focus = false;
      this.$emit("blur", e.target.name);
    },
    handleFocus(e) {
      this.focus = true;
      this.$emit("focus", e.target.name);
    },
    updateValue(e) {
      this.$emit("input", e.target.value);
    },
  },
};
